import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';
import { NotificationComponent } from '../../components/notification/notification.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-multi-asset-notification',
  templateUrl: 'multi-asset-notification.component.html',
  styleUrls: ['multi-asset-notification.component.scss'],
  imports: [
    NotificationComponent,
    IconComponent,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiAssetNotificationComponent {

}
